'use strict';

import { latLngToXY, xyToLatLng } from '@googlemaps/three';
import {
	DirectionalLight,
	Group,
	HemisphereLight,
	Scene,
	Vector3,MathUtils,
} from 'three';
import { ThreeJsOverlay } from '../overlay/ThreeJsOverlay';

export class MiniMapScene {
	
	constructor (map,params) {
		this.map = map;
		this.params = params;
		this.scene = new Scene();
		this.buildingsGroup = new Group();
		this.buildingsGroup.name = 'Project Buildings';
		this.scene.add(this.buildingsGroup);
		this.objects = new Group();
		this.objects.name = 'Scene objects';
		this.scene.add(this.objects);
		
		this.scene.position.fromArray(this.params.position);
		this.scene.rotation.fromArray(this.params.rotation);
		
		const dirLight = new DirectionalLight(0xffffff,1.3);
		dirLight.position.set(0, 500, 0);
		this.scene.add(dirLight);
		
		const hemis = new HemisphereLight('#E9EAEF','#C1C2D1',2);
		hemis.position.set(0,0,0);
		this.scene.add(hemis);
		
		const center = this.map.getCenter();
		
		this.overlay = new ThreeJsOverlay({
			anchor: {lat: center.lat(), lng:  center.lng(), altitude: 0},
			upAxis: 'Y',
			addDefaultLighting: false,
			animationMode: 'ondemand',
			scene: this.scene
		});
		
		this.overlay.setMap(this.map);
	}
	
	add(object,target) {
		if (target) {
			const obj = this.scene.getObjectByName(target);
			if (obj) {
				obj.add(object);
			} else {
				this.scene.add(object);
			}
		} else {
			this.scene.add(object);
		}
	}
	
	moveToObject(obj) {
		const position = new Vector3();
		obj.getWorldPosition(position);
		const {lat, lng} = this.vec3ToLatLngAlt(position);
		this.map.moveCamera({
			center: {
				lat,
				lng
			}
		});
	}
	
	vec3ToLatLngAlt(vec3) {
		const position = new Vector3().copy(vec3);
		position.applyQuaternion(this.overlay.rotationInverse.clone().invert());
		const z = position.z;
		const anchor = this.overlay.anchor;
		const [anchorX, anchorY] = latLngToXY(anchor);
		position.multiplyScalar(1  / Math.cos(MathUtils.degToRad(anchor.lat)));
		const {lat,lng} = xyToLatLng([position.x + anchorX, position.y + anchorY]);
		
		return {
			lat,
			lng,
			altitude: anchor.altitude + z
		}
	}
	
}
